import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Attachments_rename extends PureComponent {
  render() {
    return (
      <div className="row" id="attachments_rename">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Attachment Rename</h2>
              <p>
                To upload a file to AWS S3 you need an upload URL. The upload
                URL has a security has based on the files name and content type.
                The security has will expire after a set period.{" "}
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Attachment Rename</h2>
              <p>
                The attachment rename function allows you to rename a file
                connected to a record. To do this you need to know the file key.
                The file key can be found using the search function.
              </p>
              <p>Request:</p>
              <div className="darkCode">
                <span className="methodCodePATCH">PATCH</span> - https://
                <span className="jsonY">example</span>.api.nexoid.com/v1/record/
                <span className="jsonY">object_type</span>/
                <span className="jsonY">454</span>/attachment/rename
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"session_id"</span>:{" "}
                  <span className="jsonY">
                    "
                    <span className="jsonO">
                      &#123;&#123;session_id&#125;&#125;
                    </span>
                    "
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"key"</span>:{" "}
                  <span className="jsonY">
                    "8t33mumxa0lnxc4x/screenshot.png"
                  </span>
                  ,
                </div>
                <div className="i1">
                  <span className="jsonG">"name"</span>:{" "}
                  <span className="jsonY">"Screenshot of email.png"</span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Response:</p>
              <div className="darkCode">
                <div>
                  Code: <span className="statusCode">200</span>
                </div>
                <div>
                  <br />
                </div>
                <div>Body:</div>
                <div>&#123; &#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Attachments_rename;



// WEBPACK FOOTER //
// ./src/components/knowlege/api/Attachments_rename.js